import { render, staticRenderFns } from "./AuthNotice.vue?vue&type=template&id=3f802155"
import script from "./AuthNotice.vue?vue&type=script&lang=js"
export * from "./AuthNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports